// extracted by mini-css-extract-plugin
export default {"container":"uk-z","blurb":"vk-z","links":"wk-z"};